import React from 'react';
import { Link } from 'react-router-dom';
import './BrandDenim.css';

const BrandDenim = () => {
  const products = [
    {
      id: 1,
      name: 'classic denim',
      price: 'TBA',
      material: 'premium denim',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/denim.png',
      slug: 'classic-denim',
      available: false
    },
    {
      id: 2,
      name: 'black denim',
      price: 'TBA',
      material: 'premium denim',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/blackdenim.png',
      slug: 'black-denim',
      available: false
    }
  ];

  return (
    <div className="brand-denim">
      <div className="brand-denim__container">
        <div className="brand-denim__header">
          <Link to="/home" className="brand-denim__back">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>

          <div className="brand-denim__title">
            our denim
          </div>
        </div>

        <div className="brand-denim__grid">
          {products.map((product) => (
            <div
              key={product.id}
              className="brand-product"
            >
              <div className="brand-product__image">
                <img
                  src={product.image}
                  alt={product.name}
                  loading="lazy"
                  className="brand-product__img-blur"
                />
                <div className="brand-product__overlay">
                  <p className="brand-product__coming-soon">available in the coming months</p>
                </div>
              </div>
              <div className="brand-product__info">
                <h2 className="brand-product__name">{product.name}</h2>
                <p className="brand-product__price">{product.price}</p>
                <p className="brand-product__material">{product.material}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrandDenim;
